<template>
  <div
    class="fade page-sidebar-fixed page-header-fixed show page-container"
    v-if="authenticated || !pageOptions.pageEmpty"
    v-bind:class="{
      'page-sidebar-minified': pageOptions.pageSidebarMinified,
      'page-content-full-height': pageOptions.pageContentFullHeight,
      'page-without-sidebar': pageOptions.pageWithoutSidebar,
      'page-with-right-sidebar': pageOptions.pageWithRightSidebar,
      'page-with-two-sidebar': pageOptions.pageWithTwoSidebar,
      'page-with-wide-sidebar': pageOptions.pageWithWideSidebar,
      'page-with-light-sidebar': pageOptions.pageWithLightSidebar,
      'page-with-top-menu': pageOptions.pageWithTopMenu,
      'page-sidebar-toggled': pageOptions.pageMobileSidebarToggled,
      'page-right-sidebar-toggled':
        pageOptions.pageMobileRightSidebarToggled ||
        pageOptions.pageRightSidebarToggled,
      'has-scroll': pageOptions.pageBodyScrollTop
    }"
  >
    <Header v-if="authenticated"/>
    <TopMenu v-if="pageOptions.pageWithTopMenu && authenticated" />
    <Sidebar v-if="!pageOptions.pageWithoutSidebar && authenticated" />
    <SidebarRight v-if="pageOptions.pageWithTwoSidebar && authenticated" />
    <div
      id="content"
      class="content"
      v-bind:class="{
        'content-full-width': pageOptions.pageContentFullWidth,
        'content-inverse-mode': pageOptions.pageContentInverseMode
      }"
    >
      <router-view></router-view>
      <vue-ins-progress-bar></vue-ins-progress-bar>
    </div>
    <Footer v-if="pageOptions.pageWithFooter" />
    <dialogs-wrapper tag="div" />
    <ts-lock-screen v-if="authenticated" v-show="isLock" @reset="resetTimer"></ts-lock-screen>
  </div>
  <div v-else-if="authenticated && pageOptions.pageEmpty">
    <router-view></router-view>
    <vue-ins-progress-bar></vue-ins-progress-bar>
    <ts-lock-screen v-show="isLock" @reset="resetTimer"></ts-lock-screen>
  </div>
  <div v-else>
    <router-view></router-view>
    <vue-ins-progress-bar></vue-ins-progress-bar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Sidebar from './components/sidebar/Sidebar.vue'
import SidebarRight from './components/sidebar-right/SidebarRight.vue'
import Header from './components/header/Header.vue'
import TopMenu from './components/top-menu/TopMenu.vue'
import Footer from './components/footer/Footer.vue'
import PageOptions from './config/PageOptions.vue'

export default {
  name: 'app',
  components: {
    Sidebar,
    SidebarRight,
    Header,
    TopMenu,
    Footer
  },
  data () {
    return {
      pageOptions: PageOptions,
      lock: false,
      lockTimer: null,
      events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load']
    }
  },
  computed: {
    ...mapGetters(['authenticated']),
    isLock () {
      if (this.$route.name == 'pickup-display') {
        return false
      }
      return this.$store.state.isLockScreen
    },
    company () {
      if (this.$store.state.authUser) {
        return this.$store.state.authUser.company
      }
      return null
    }
  },
  methods: {
    handleIcon () {
      // accessing the link tag
      const favicon = document.getElementById('favicon')
      const title = document.getElementById('title')
      title.innerHTML = this.company.company_name_en
      favicon.href = this.company.favicon
    },
    handleScroll: function () {
      PageOptions.pageBodyScrollTop = window.scrollY
    },
    setTimer () {
      if (this.authenticated) {
        this.lockTimer = setTimeout(() => {
          this.$store.commit('setIsLock', 1)
          localStorage.setItem('!z_dy#@_____00111$%!@', 1)
        }, 300 * 10000)
      }
    },
    resetTimer () {
      clearTimeout(this.lockTimer)
      this.setTimer()
    }
  },
  mounted () {
    this.$insProgress.finish()
    this.events.forEach(event => {
      window.addEventListener(event, this.resetTimer)
    })

    this.setTimer()
    if (this.company) {
      this.handleIcon()
    }
  },
  created () {
    PageOptions.pageBodyScrollTop = window.scrollY

    window.addEventListener('scroll', this.handleScroll)

    this.$insProgress.start()

    this.$router.beforeEach((to, from, next) => {
      this.$insProgress.start()
      next()
    })
    this.$router.afterEach(() => {
      this.$insProgress.finish()
    })
  }
}
</script>
